import {Col, Row} from '@jetbrains/ring-ui/components/grid/grid'
import classNames from 'classnames'
import * as React from 'react'

import MiddleEllipsis from '../../../../common/MiddleEllipsis/MiddleEllipsis'
import rowStyles from '../../rows/TestRow/TestRow.css'

import styles from './TestsTableHeader.css'

type Props = {
  sourceBuildNumber: string | null | undefined
  compareBuildNumber: string | null | undefined
}

function TestsTableHeader({sourceBuildNumber, compareBuildNumber}: Props) {
  return (
    <Row className={classNames(rowStyles.row, styles.header)}>
      <Col className={rowStyles.nameCol}>{'Test'}</Col>
      <Col className={rowStyles.statusCol}>
        {sourceBuildNumber != null ? (
          <MiddleEllipsis>{`#${sourceBuildNumber}`}</MiddleEllipsis>
        ) : (
          '1st status'
        )}
      </Col>
      <Col className={rowStyles.statusCol}>
        {compareBuildNumber != null ? (
          <MiddleEllipsis>{`#${compareBuildNumber}`}</MiddleEllipsis>
        ) : (
          '2nd status'
        )}
      </Col>
      <Col className={rowStyles.durationCol}>{'Duration'}</Col>
      <Col className={rowStyles.durationDiffCol} />
    </Row>
  )
}

export default TestsTableHeader
